import { Box, Text, Stack } from '@stitch-fix/mode-react';
import clsx from 'clsx';
import { useWardrobeCopy } from '../../utils/contexts/copy-provider';
import { useWardrobeParams } from '../../utils/hooks/useWardrobeParams';
import styles from './styles.module.scss';
const options = [{
  label: 'Bought',
  value: 'bought-items'
}, {
  label: 'Saved',
  value: 'saved-items'
}] as const;

/**
 * The `Wardrobe Navigation` controls houses the headline, sub-headline, and navigation
 * between the tabs for the Wardrobe experience. It currently toggles between Saved Items
 * Bought Items
 */
const WardrobeNavigation = () => {
  const {
    wardrobePage
  } = useWardrobeParams();
  const {
    copy
  } = useWardrobeCopy();
  return <Stack mb={1.5} spacing={0} hAlign="center">
      <Text as="h1" setting="title-large" mb={0.5}>
        {copy.heading}
      </Text>
      <Text as="p" setting="subtitle-small" mb={0.5} color="gray-35">
        {copy.subheading}
      </Text>
      <Box className={styles.navigation} style={{
      marginTop: '0.5rem'
    }}>
        {options.map(option => {
        const isSelected = wardrobePage === option.value;
        return <a key={option.value} href={`/wardrobe/${option.value}`} className={clsx(styles.navigationLink, {
          [styles.isSelected]: isSelected
        })} aria-current={isSelected ? 'page' : undefined} data-testid={`${option.value}-label`}>
              {option.label}
            </a>;
      })}
      </Box>
    </Stack>;
};
export default WardrobeNavigation;